import {usePeutVoirDlcStock} from '@/hooks/auth/usePermissionsCommerciales';

/**
 * Hauteur d'une case des grilles de vignettes de remplacement.
 *
 * Partagée par la modale de remplacement et le side panel des UB, qui affichent la même
 * vignette. En mobile, rien dans la vignette ne rétrécit : sans les 45 px de la rangée
 * DLC et stock, le bouton d'action sort de la case et passe sous la vignette suivante.
 */
export function useHauteurVignetteRemplacement(isMobile: boolean): number {
  const peutVoirDlcStock = usePeutVoirDlcStock();
  if (isMobile) {
    return peutVoirDlcStock ? 300 : 255;
  }
  return peutVoirDlcStock ? 490 : 450;
}
